import React from 'react';
import { RowDefaultProps } from "./Grille.types";
var Row = function (_a) {
    var children = _a.children, goutierre = _a.goutierre, alignementHorizontal = _a.alignementHorizontal, alignementVertical = _a.alignementVertical, className = _a.className;
    var classRow = 'fr-grid-row';
    if (goutierre) {
        classRow += ' fr-grid-row--gutters';
    }
    if (alignementHorizontal) {
        classRow += " fr-grid-row--".concat(alignementHorizontal);
    }
    if (alignementVertical) {
        classRow += " fr-grid-row--".concat(alignementVertical);
    }
    if (className) {
        classRow += " ".concat(className);
    }
    return (React.createElement("div", { className: classRow }, children));
};
Row.defaultProps = RowDefaultProps;
export default Row;
